import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { AirlineIcon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Airline.module.scss";

export interface AirlineComponentProps extends PlatformComponentProps {
  code: string;
  name: string;
  hideIcon?: boolean;
}
export const Airline = ({
  className,
  code,
  name,
  hideIcon,
  children,
}: AirlineComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.Airline;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      {(hideIcon ?? false) ? null : (
        <AirlineIcon
          airlineCode={code}
          altText={name}
          className={cn("airline-icon")}
        />
      )}{" "}
      {name}
      {children}
    </div>
  );
};
